import { Component } from '@angular/core';
import { TranslatorPipe } from '../services/translator.pipe';
import { OrgUnitsService } from '../services/org-units.service';
import { DataService } from '../services/data.service';
import { breadcrumb } from '../admin/layout/header/header.component';
import { GlobalConstants } from '../services/global-constants';

@Component({
  selector: 'app-investor-controller',
  templateUrl: './investor-controller.component.html',
  styleUrl: './investor-controller.component.scss'
})
export class InvestorControllerComponent {
  title: string = this.translate("Admin Permission Panel")
  loading: boolean = true;
  staticURL = GlobalConstants.staticFilesURL;
  treeData: any;
  messages: any[] = [];

  breadcrumbs: breadcrumb[] = [
    { name: this.title, link: '/investor-admin' },
  ];

  payload: any = {
    content: {
      allow: false,
      signedOus: [],
      allOus: []
    },
    kLibrary: {
      allow: false,
      ou: [],
      categories: []
    },
    dataView: {
      allow: false,
      allowPrint: false,
      signedOus: [],
      allOus: []
    }
  }

  categories: any[] = [];
  fields: any[] = [];


  constructor(
    private dataService: DataService,
    private orgUnits: OrgUnitsService,
  ) { }


  translate(text: string) {
    return new TranslatorPipe().transform(text)
  }

  ngOnInit(): void {
    Promise.all([this.getTreeData(), this.getCategories(), this.getFieldData()]).then(() => {
      this.getData().then(() => {
        this.loading = false;
      })

    })
  }

  getCategories = async () => {
    this.categories = [];
    try {
      let res = await this.dataService.getData('knowledge-library-category');
      if (res.error) return;
      this.categories = res.data;
    } catch (error) {
      console.log(error);
    }
  };

  getFieldData = async () => {
    try {
      let res = await this.dataService.postData('data-fields/get/', {});
      if (res.error) return;
      this.fields = res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getTreeData() {
    this.treeData = await this.orgUnits.getOrgUnits()
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  async getData() {
    let res = await this.dataService.getData('permission/investor-permission')
    if (res.error) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: res.msg },
      ];
      return;
    }
    let data = res.data;
    this.payload = {
      content: {
        allow: data.content.allow,
        signedOus: this.mapOus(data.content.signedOus),
        allOus: this.mapOus(data.content.allOus)
      },
      kLibrary: {
        allow: data.kLibrary.allow,
        ou: this.mapOus(data.kLibrary.ou),
        categories: data.kLibrary.categories,
      },
      dataView: {
        allow: data.dataView.allow,
        allowPrint: data.dataView.allowPrint,
        signedOus: this.mapOus(data.dataView.signedOus),
        allOus: this.mapOus(data.dataView.allOus),
      },
      templateHide: {
        fields: data.templateHide.fields
      }
    };
  }


  private mapOus(data: any[]) {
    return data.map((e: any) => this.orgUnits.findBy_Id(this.treeData, e)).filter((e: any) => e != null && e != undefined);
  }

  async onSubmit() {
    let finalPayload = {
      content: {
        allow: this.payload.content.allow,
        signedOus: this.payload.content.signedOus.map((e: any) => e._id),
        allOus: this.payload.content.allOus.map((e: any) => e._id)
      },
      kLibrary: {
        allow: this.payload.kLibrary.allow,
        ou: this.payload.kLibrary.ou.map((e: any) => e._id),
        categories: this.payload.kLibrary.categories,
      },
      dataView: {
        allow: this.payload.dataView.allow,
        allowPrint: this.payload.dataView.allowPrint,
        signedOus: this.payload.dataView.signedOus.map((e: any) => e._id),
        allOus: this.payload.dataView.allOus.map((e: any) => e._id),
      },
      templateHide: {
        fields: this.payload.templateHide.fields
      }
    }
    let res = await this.dataService.postData('permission/investor-permission', finalPayload)

    if (res.error) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: res.msg },
      ];
      return;
    }
    this.messages = [
      { severity: 'success', summary: this.translate('success'), detail: res.msg },
    ];

  }


}
